export enum AnnouncementName {
  FLASH_SALE_SPRING_2025 = 'FLASH_SALE_SPRING_2025',
  FIRESHIP_2025 = 'FIRESHIP_2025',
}
